import React from 'react';
import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Amplify from 'aws-amplify';
import { withAlert } from 'react-alert';
import { Link } from 'react-router-dom';
import * as SecretKeys from '../../ENV.json';
import { confirmUserEmail, getCognitoIdByEmail, confirmCognitoUserEmail } from '../../Actions/actions';
import TextFieldGroup from '../common/TextFieldGroup';
import CodeTextFieldGroup from '../common/CodeTextFieldGroup';
import Header from '../Header/header';

Amplify.configure(SecretKeys.awsUserpool);

class VerifyCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      code: '',
      errors: {},
      isLoading: false,
      IsCaptchaTrue: true,
      failedMessages: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.onCatchaChange = this.onCatchaChange.bind(this);
  }

  componentWillUnmount() {
    this.setState({
      email: '',
      code: '',
      errors: {},
      isLoading: false,
      IsCaptchaTrue: false,
      failedMessages: '',
      displayCodeDiv: false,
    });
  }

  onChange(e) {
    this.setState({ errors: {}, isLoading: true, failedMessages: '' });
    this.setState({ [e.target.name]: e.target.value });
  }

  isValid() {
    const { errors, isValid } = this.validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  }

  validateInput(data) {
    const errors = {};
    if (Validator.isEmpty(data.email)) {
      errors.email = 'Email is required';
      errors.emailError = true;
    }

    if (Validator.isEmpty(data.code)) {
      errors.code = 'code is required';
      errors.codeError = true;
    }

    if (!data.IsCaptchaTrue) {
      errors.captcha = 'Captcha is Not validated';
      errors.captchaError = true;
    }

    return {
      errors,
      isValid: isEmpty(errors),
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isValid()) {
      this.setState({ errors: {}, isLoading: true });
      if (this.state.code !== '') {
        this.props.confirmCognitoUserEmail(this.state);
      } else {
        const errors = {};
        errors.code = 'Code is required';
        this.setState({
          errors,
        });
      }
    }
  }

  onCatchaChange(value) {
    if (value !== '') {
      this.setState({ IsCaptchaTrue: true });
    }
  }

  componentWillReceiveProps(nextProps) {
    const CognitoEmail = nextProps.data.CognitoEmail;
    const confirmCognitoUserEmailData = nextProps.data.ConfirmCognitoUserEmailData;
    if (CognitoEmail.code === 400) {
      this.setState({
        failedMessages: 'Email id not found',
      });
      this.setState({ displayCodeDiv: false });
    } else if (CognitoEmail.code === 200) {
      this.setState({ displayCodeDiv: true });
    }
    if (confirmCognitoUserEmailData.code === 400) {
      this.setState({
        failedMessages: 'Invalid email id or code',
      });
    } else if (confirmCognitoUserEmailData.code === 200) {
      this.context.router.history.push('/');
    }
  }

    onBlurHandle = () => {
      // console.log(this.state.email);
      this.props.getCognitoIdByEmail(this.state.email);
    }

    render() {
      const {
        errors, email, code, failedMessages, displayCodeDiv,
      } = this.state;
      // let data = this.props.data;
      let codeDiv;

      if (displayCodeDiv) {
        codeDiv = (
          <div className="input-field col s12">
            <TextFieldGroup
              field="code"
              label="code"
              value={code}
              error={errors.code}
              onChange={this.onChange}
            />
          </div>
        );
      } else {
        codeDiv = (<div />);
      }

      return (
        <span>

          <div className="container">
            <div className="main-content">
              <Header />

              <div className="section-content center-align login-content">
                <h2>Verify Code</h2>
                <span className="show">
                  {failedMessages}
                  {' '}
                </span>
                <div className="row">
                  <form className="col s8 offset-s2" onSubmit={this.handleSubmit}>
                    <div className="row">
                      <div className="input-field col s12">
                        <CodeTextFieldGroup
                          field="email"
                          label="Username / Email"
                          value={email}
                          error={errors.email}
                          onChange={this.onChange}
                          checkEmail={this.onBlurHandle}
                        />
                      </div>

                      { codeDiv }
                      {/* <div className="col s12">
                                    <div className="recapcha z-depth-2"> <ReCAPTCHA
                                        ref="recaptcha"
                                        sitekey={SecretKeys.CaptchKeys}
                                        onChange={this.onCatchaChange}
                                    />
                                    <span className={(errors.captchaError ? 'show' : 'hide')}>{errors.captcha}</span>
                                    </div>
                                </div> */}
                      <div className="col s12">
                        <button
                          className="btn waves-effect waves-light primary-btn col s12"
                          type="submit"
                          name="action"
                        >
Verify
                          <i className="material-icons">arrow_forward</i>
                        </button>
                      </div>
                      <div className="col s12">
                        <div className="create-account">
                          <h5>
Already verified account?
                            {' '}
                            <Link to="/">Login</Link>
                          </h5>
                        </div>
                      </div>

                    </div>
                  </form>
                </div>

              </div>
            </div>

          </div>
        </span>
      );
    }
}

VerifyCode.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getCognitoIdByEmail, confirmUserEmail, confirmCognitoUserEmail }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(VerifyCode));
